import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { FcOutlinedInputModule } from '@core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { TreeViewModule } from '@core/components/fc-tree-view/fc-tree-view.module';
import { TreeViewService } from '@core/components/fc-tree-view/fc-tree-view.service';
import { VideoInfoModalModule } from '@core/components/video-info-modal/video-info-modal.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogEquipmentService } from 'app/main/equipments/dialog/dialog-equipments.service';
import { DialogLinkModule } from './dialog-link/dialog-link.module';
import { DialogLinkService } from './dialog-link/dialog-link.service';
import { TabLinksComponent } from './tab-links.component';
import { TabLinksService } from './tab-links.service';

@NgModule({
  entryComponents: [
    TabLinksComponent
  ],
  declarations: [
    TabLinksComponent
  ],
  exports: [
    TabLinksComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    DialogLinkModule,
    FcOutlinedInputModule,
    TreeViewModule,
    VideoInfoModalModule
  ],
  providers: [
    TabLinksService,
    DialogLinkService,
    DialogEquipmentService,
    TreeViewService
  ],
})
export class TabLinksModule {}
